import type { FC } from "react";
import type { ContentFileDto } from "shared";
import { Icon } from "../../common/Icon";
import { PreviewMedia } from "../shared/PreviewMedia";
import "./TikTokPreview.css";

interface TikTokPreviewProps {
	companyName: string;
	content: string;
	files: ContentFileDto[];
}

export const TikTokPreview: FC<TikTokPreviewProps> = ({
	companyName,
	content,
	files,
}) => {
	const username = companyName.toLowerCase().replace(/\s+/g, "");
	const initials = companyName
		.split(" ")
		.map((part) => part[0])
		.join("")
		.slice(0, 2)
		.toUpperCase();

	return (
		<div className="tt-preview">
			<div className="tt-preview__frame">
				<div className="tt-preview__media">
					<PreviewMedia files={files} aspectRatio="9:16" />

					<div className="tt-preview__overlay">
						<div className="tt-preview__sidebar">
							<div className="tt-preview__profile">
								<div className="tt-preview__avatar">{initials}</div>
								<span className="tt-preview__follow">+</span>
							</div>

							<button type="button" className="tt-preview__action">
								<Icon name="favorite" size={28} />
								<span>12.4K</span>
							</button>
							<button type="button" className="tt-preview__action">
								<Icon name="chat_bubble" size={28} />
								<span>348</span>
							</button>
							<button type="button" className="tt-preview__action">
								<Icon name="bookmark" size={28} />
								<span>892</span>
							</button>
							<button type="button" className="tt-preview__action">
								<Icon name="send" size={28} />
								<span>Share</span>
							</button>
						</div>

						<div className="tt-preview__footer">
							<div className="tt-preview__username">@{username}</div>
							{content.trim().length > 0 && (
								<p className="tt-preview__caption">{content}</p>
							)}
							<div className="tt-preview__sound">
								<span className="tt-preview__sound-icon" aria-hidden>
									♪
								</span>
								<span>Original sound — {companyName}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
